import React from "react"
import Link from "gatsby-link"
import './Feature.css';

class Feature extends React.Component {
  render() {
    const {children, Icon, comingSoon} = this.props;
    return (
      <div className="Feature">
        {Icon && <Icon className="Feature-Icon" />}
        {comingSoon && <div className="Feature-ComingSoon">
          Coming Soon
        </div>}
        {children}
      </div>
    )
  }
}

Feature.propTypes = {
  comingSoon: React.PropTypes.bool,
  Icon: React.PropTypes.any
}

export default Feature;



// WEBPACK FOOTER //
// ./src/pages/index/Feature.js